import { APIDateFormat, UIDateFormat } from "@helpers/dates";
import moment from "moment";
import React from "react";
import { DateInput } from "semantic-ui-calendar-react";
import { Form } from "semantic-ui-react";

const ReportsDatepicker = (props) => {
  const handleChange = (event, { name, value }) => {
    const formatDate = moment(value, UIDateFormat).format(APIDateFormat);
    props.onChange(name, formatDate);
  };

  return (
    <Form.Field inline required={props.isRequired}>
      <label>{props.text}</label>
      <DateInput
        className="ui input"
        name={props.text}
        placeholder="Choose a date.."
        iconPosition="left"
        animation="fade"
        popupPosition="bottom center"
        closable
        autoComplete="off"
        dateFormat={UIDateFormat}
        value={
          props.value
            ? moment(props.value, APIDateFormat).format(UIDateFormat)
            : null
        }
        onChange={handleChange}
      />
    </Form.Field>
  );
};

export default ReportsDatepicker;
